module.exports = __webpack_public_path__ + "img/insta_claro.371b2c34.svg";